export default __webpack_public_path__ + "static/media/pic3.220ca0f7.jpg";